module.exports = __webpack_public_path__ + "static/media/blog-37-img5.4305799e.webp";